import { __read } from "tslib";
import { useCallback, useState } from 'react';
import { useIsomorphicLayoutEffect } from '@use-platform/react/libs/isomorphic-layout-effect';
export var canUseDOM = typeof window !== 'undefined';
export var getClientHeight = function () { return window.innerHeight || document.documentElement.clientHeight ||
    document.body.clientHeight; };
export var useIframeMaxHeight = function (options) {
    var enabled = options.enabled, onHeightChange = options.onHeightChange;
    var _a = __read(useState(canUseDOM ? getClientHeight() : undefined), 2), clientHeight = _a[0], setClientHeight = _a[1];
    var recalculateHeight = useCallback(function () {
        var newHeight = getClientHeight();
        if (clientHeight !== newHeight) {
            setClientHeight(getClientHeight());
            onHeightChange(newHeight);
        }
    }, [clientHeight, onHeightChange]);
    useIsomorphicLayoutEffect(function () {
        if (!enabled)
            return;
        window.addEventListener('resize', recalculateHeight);
        return function () {
            window.removeEventListener('resize', recalculateHeight);
        };
    }, [recalculateHeight, enabled]);
};
